"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingMask = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
/**
 * @internal
 */
exports.LoadingMask = function (props) {
    var className = props.className, height = props.height, width = props.width, size = props.size;
    var style = react_1.useMemo(function () { return ({
        width: width,
        height: height,
    }); }, [width, height]);
    var spinnerSize = size ? size : "large";
    return (react_1.default.createElement("div", { style: style, "aria-label": "loading", className: classnames_1.default("s-isLoading", "loading-mask", className) },
        react_1.default.createElement("div", { className: classnames_1.default("gd-spinner", spinnerSize) })));
};
//# sourceMappingURL=LoadingMask.js.map